module.exports = __webpack_public_path__ + "static/media/l_itdot_8.07b221dd.png";